<template>
  <div
    class="d-flex flex-column align-center justify-end"
    style="min-height:100vh; min-width:100vw"
  >
    <div class="clock">
      <p class="white--text mb-0 font-weight-bold">{{timer | minuteSeconds}}</p>
    </div>

    <div id="remote">
      <div
        v-if="!acceptedCall && loading"
        class="justify-self-center align-self-center d-flex flex-column align-center justify-center"
      >
        <img style="height:200px; width:200px" src="@/assets/doc.png" alt />
        <p class="mb-0 text-center mt-2 white--text" v-if="loading">Η βιντεοκλήση είναι σε εξέλιξη.</p>
        <p class="text-center white--text" v-if="loading">Παρακαλώ περιμένετε...</p>
      </div>
    </div>

    <div v-show="!disabled" id="local"></div>

    <div class="buttons d-flex justify-center align-center mb-12 mr-12">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="50"
            width="50"
            fab
            depressed
            outlined
            color="white"
            v-on="on"
            @click="disableMic"
          >
            <v-icon v-if="!disabledMic">mdi-microphone-off</v-icon>
            <v-icon v-else>mdi-microphone</v-icon>
          </v-btn>
        </template>
        <span>{{disabledMic ? 'Άνοιγμα μικρόφωνου' : 'Κλείσιμο μικρόφωνου'}}</span>
      </v-tooltip>

      <v-btn
        height="50"
        width="50"
        fab
        depressed
        color="rgb(255,0,0)"
        class="white--text ml-2"
        v-if="invitationSent"
        @click="end"
      >
        <v-icon>mdi-phone-hangup</v-icon>
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="ml-2"
            height="50"
            width="50"
            fab
            depressed
            outlined
            color="white"
            v-on="on"
            @click="disable"
          >
            <v-icon v-if="!disabled">mdi-video-off</v-icon>
            <v-icon v-else>mdi-video</v-icon>
          </v-btn>
        </template>
        <span>{{disabled ? 'Άνοιγμα κάμερας' : 'Κλείσιμο κάμερας'}}</span>
      </v-tooltip>
    </div>

    <v-dialog persistent v-model="dialog" width="400">
      <v-card>
        <v-card-text>
          <div
            v-if="!!object && !!object.standByDoctorId"
            class="d-flex flex-column justify-center align-center pa-2"
          >
            <h2 class="text-center mt-5 font-weight-light">Ο γιατρός δεν απαντά.</h2>
            <p
              class="text-center mt-2"
            >Μπορούμε να μεταφέρουμε αυτόματα την κλήση σας στον επόμενο διαθέσιμο γιατρό.</p>
            <div
              class="d-flex align-start justify-center py-3 px-12"
              style="background-color:rgb(247,247,247)"
            >
              <img src="@/assets/doc.png" alt  style="height:50px; background-color:rgb(200,200,200); border-radius: 50%"/>

              <div class="d-flex flex-column ml-5">
                <h3
                  class="font-weight-bold mb-0 black--text"
                >{{(!!object ? object.standByDoctorFirstName : '') + ' ' + (!!object ? object.standByDoctorLastName : '')}}</h3>
                <p class="mb-0">{{!!object ? object.standByDoctorTypeName : ''}}</p>
                <p class="mb-0">Νομός: {{!!object ? object.standByDoctorPrefecture : ''}}</p>
              </div>
            </div>
            <!-- <div class="d-fle">
              <v-btn @click="$router.replace('/emergency/doctors')">oxi</v-btn>
              <v-btn @click="reInvite">nai</v-btn>
            </div>-->
            <v-btn
              width="180"
              height="40"
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize my-5"
              @click="reInvite"
            >
              <p class="mb-0">Εντάξει</p>
            </v-btn>
            <!-- <div style="height:1px; background-color:rgb(240,240,240);width:80%;"></div> -->
            <v-btn text color="black" class="text-capitalize mt-5" @click="reInviteInitial">
              <p class="mb-0">Επανάληψη κλήσης στον ίδιο γιατρό</p>
            </v-btn>
            <v-btn
              text
              color="red"
              class="text-capitalize"
              @click="$router.replace('/emergency/doctors')"
            >
              <p class="mb-0 font-weight-bold">Ακύρωση</p>
            </v-btn>
          </div>

          <div v-else class="d-flex flex-column justify-center align-center pa-2">
            <h2 class="text-center mt-5 font-weight-light">Ο γιατρός δεν απαντά.</h2>
            <p
              class="text-center mt-4"
            >Δυστηχώς, δεν υπάρχει κανένας άλλος διαθέσιμος γιατρός αυτή την στιγμή.</p>
            <p class="text-center mt-2">
              Παρακαλώ δοκιμάστε ξανά αργότερα ή καλέστε μας στο
              <span
                class="font-weight-bold"
              >+(30) 212 10 42 659</span> για να μπορέσουμε να σας εξυπηρετήσουμε.
            </p>
            <v-btn
              rounded
              color="rgb(0,170,221)"
              depressed
              width="180"
              height="40"
              class="text-capitalize white--text mt-4"
              @click="connection.stop();$router.replace('/emergency/doctors')"
            >
              <p class="mb-0">Εντάξει</p>
            </v-btn>
            <!-- <div style="height:1px; background-color:rgb(240,240,240);width:80%;"></div> -->
            <v-btn text color="black" class="text-capitalize mt-5" @click="reInviteInitial">
              <p class="mb-0">Επανάληψη κλήσης στον ίδιο γιατρό</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="declineDialog" width="400">
      <v-card>
        <v-card-text>
          <div
            v-if="!!object && !!object.standByDoctorId"
            class="d-flex flex-column justify-center align-center pa-2"
          >
            <h2 class="text-center mt-5 font-weight-light">Ο γιατρός δεν μπορεί να σας μιλήσει αυτή την στιγμή.</h2>
            <p
              class="text-center mt-2"
            >Μπορούμε να μεταφέρουμε αυτόματα την κλήση σας στον επόμενο διαθέσιμο γιατρό.</p>
            <div
              class="d-flex align-start justify-center py-3 px-12"
              style="background-color:rgb(247,247,247)"
            >
              <img src="@/assets/doc.png" alt  style="height:50px; background-color:rgb(200,200,200); border-radius: 50%"/>

              <div class="d-flex flex-column ml-5">
                <h3
                  class="font-weight-bold mb-0 black--text"
                >{{(!!object ? object.standByDoctorFirstName : '') + ' ' + (!!object ? object.standByDoctorLastName : '')}}</h3>
                <p class="mb-0">{{!!object ? object.standByDoctorTypeName : ''}}</p>
                <p class="mb-0">Νομός: {{!!object ? object.standByDoctorPrefecture : ''}}</p>
              </div>
            </div>
            <!-- <div class="d-fle">
              <v-btn @click="$router.replace('/emergency/doctors')">oxi</v-btn>
              <v-btn @click="reInvite">nai</v-btn>
            </div>-->
            <v-btn
              width="180"
              height="40"
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize my-5"
              @click="reInvite"
            >
              <p class="mb-0">Εντάξει</p>
            </v-btn>
            <v-btn
              text
              color="red"
              class="text-capitalize"
              @click="connection.stop();$router.replace('/emergency/doctors')"
            >
              <p class="mb-0 font-weight-bold">Ακύρωση</p>
            </v-btn>
          </div>

          <div v-else class="d-flex flex-column justify-center align-center pa-2">
            <h2 class="text-center mt-5 font-weight-light">Ο γιατρός δεν μπορεί να σας μιλήσει αυτή την στιγμή.</h2>
            <p
              class="text-center mt-4"
            >Δυστηχώς, δεν υπάρχει κανένας άλλος διαθέσιμος γιατρός αυτή την στιγμή.</p>
            <p class="text-center mt-2">
              Παρακαλώ δοκιμάστε ξανά αργότερα ή καλέστε μας στο
              <span
                class="font-weight-bold"
              >+(30) 212 10 42 659</span> για να μπορέσουμε να σας εξυπηρετήσουμε.
            </p>
            <v-btn
              rounded
              color="rgb(0,170,221)"
              depressed
              width="180"
              height="40"
              class="text-capitalize white--text mt-4"
              @click="connection.stop();$router.replace('/emergency/doctors')"
            >
              <p class="mb-0">Εντάξει</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
const { connect, createLocalVideoTrack } = require("twilio-video");
const signalR = require("@microsoft/signalr");
const DetectRTC = require("detectrtc");
import { Howl, Howler } from "howler";
export default {
  data() {
    return {
      room: null,
      connection: null,
      object: null,
      disabled: false,
      disabledMic: false,
      localTrack: null,
      acceptedCall: false,
      invitationSent: false,
      timer: 0,
      interval: null,
      timeouted: false,
      loading: true,

      sound: null,

      dialog: false,
      declineDialog: false
    };
  },

  destroyed() {
    this.sound.stop();
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
    console.log("back");
    if (this.localTrack !== null) {
      this.localTrack.stop();
    }
    if (!!this.room) {
      // if (this.room.state === "connected") {
      this.room.disconnect();
      console.log("disconnected from destroyed");
      // }
      this.localTrack.stop();

      //  this.end();
    }
    this.$store.dispatch("clearCallData");

    // .then(() => {

    // });

    //  console.log(this.connection)
    //  if(this.connection.state == 'Connected'){
    //    this.connection.stop()
    //  }

    // .then()
    // .catch(err => {
    //   console.log('xa09xa0axx0a',err)
    // })
  },

  created() {
    window.addEventListener("beforeunload", () => {
      if (!!this.room) {
        this.room.disconnect();
      }

      //  if(!!room){
      //    console.log('reload desconnect')
      //    this.room.disconnect()
      //  }

      if (!acceptedCall) {
        this.connection.invoke("cancelCall", this.object);
        this.$store.dispatch("clearCallData");
      } else {
        this.connection.invoke("endCall", this.object);
        this.$store.dispatch("clearCallData");
      }
    });

    this.sound = new Howl({
      src: ["call2.wav"],
      volume: 1.0,
      loop: true
    });

    this.sound.play();

    if (this.$store.state.doctorId === null) {
      if (!!this.room) {
        this.room.disconnect();
      }
      // this.$router.go(-1);
      this.$router
        .replace("/home")
        .then()
        .catch(err => {});
    }
    if (!!this.connection) {
      this.connection.stop();
    }
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(
        `https://cn2me-${
          process.env.VUE_APP_environment
        }-backend.azurewebsites.net/notificationHub?token=${
          this.$store.state.token
        }&operatingSystem=${DetectRTC.osName.toLowerCase()}&appType=browser`
      )
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    this.connection
      .start()
      .then(() => {
        console.log("conna");
        console.log("DOCTORID", this.$store.state.doctorId);
        this.connection
          .invoke("inviteDoctor", {
            videoCallRoom: null,
            travellerId: this.$store.state.user.travellerID,
            travellerFirstName: null,
            travellerLastName: null,
            travellerTwilioToken: null,
            doctorId: this.$store.state.doctorId,
            doctorFirstName: null,
            doctorLastName: null,
            doctorTwilioToken: null
          })
          .then(res => console.log(res));
      })
      .catch(err => {
        console.log(err);
      });

    this.connection.on("invitationSent", res => {
      this.object = res;
      this.invitationSent = true;
      console.log("inv sent");
    });

    this.connection.on("declinedCall", res => {
      // this.$router.go(-1);
      //  this.connection.stop();
      // this.$store.dispatch("declined", true).then(() => {
      //   this.$router
      //     .replace("/emergency/doctors")
      //     .then()
      //     .catch(err => {});
      //   console.log("declined");
      // });
      console.log(res);
      this.sound.stop();
      this.object = res;
      this.declineDialog = true;

      // this.$store.dispatch("clearCallData");
    });

    this.connection.on("endedCall", res => {
      this.connection.stop();
      this.$router
        .replace("/emergency/doctors")
        .then()
        .catch(err => {});
    });

    this.connection.on("acceptedCall", res => {
      console.log("doctor incoming");
      this.loading = false;
      this.sound.stop();
      this.showCam(this.object.videoCallRoom, this.object.travellerTwilioToken);
    });

    this.connection.on("timedOutCall", res => {
      this.sound.stop();
      this.object = res;
      this.dialog = true;

      console.log(res);
      // this.timeouted = true;
      // this.$store.dispatch("timeout", true).then(() => {
      //   this.$router
      //     .replace("/emergency/doctors")
      //     .then()
      //     .catch(err => {});
      //   console.log("time out");
      // });

      //  console.log(res)

      // this.showCam(res.videoCallRoom, res.travellerTwilioToken);
    });

    // this.connection.on("endedCall", res => {
    //   this.$router.go(-1);
    //    console.log('ended')
    //   //this.$store.dispatch("clearCallData");
    // });
  },

  mounted() {},

  methods: {
    reInvite() {
      this.sound.play();
      this.dialog = false;
      this.declineDialog = false;
      this.connection
        .invoke("inviteDoctor", {
          videoCallRoom: null,
          travellerId: this.$store.state.user.travellerID,
          travellerFirstName: null,
          travellerLastName: null,
          travellerTwilioToken: null,
          doctorId: this.object.standByDoctorId,
          doctorFirstName: null,
          doctorLastName: null,
          doctorTwilioToken: null
        })
        .then(res => console.log(res));
    },
    reInviteInitial() {
      this.sound.play();
      this.dialog = false;
      this.declineDialog = false;
      this.connection.invoke("inviteDoctor", {
        videoCallRoom: null,
        travellerId: this.$store.state.user.travellerID,
        travellerFirstName: null,
        travellerLastName: null,
        travellerTwilioToken: null,
        doctorId: this.$store.state.doctorId,
        doctorFirstName: null,
        doctorLastName: null,
        doctorTwilioToken: null
      });
    },
    disable() {
      this.disabled = !this.disabled;
      if (this.disabled === true) {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.disable();
        });
      } else {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.enable();
        });
      }
    },
    disableMic() {
      this.disabledMic = !this.disabledMic;
      if (this.disabledMic === true) {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.disable();
        });
      } else {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.enable();
        });
      }
    },
    end() {
      //  this.connection.invoke('endCall', this.object)

      if (this.interval !== null) {
        clearInterval(this.interval);
      }
      if (!this.timeouted) {
        if (!this.acceptedCall) {
          console.log("you cancel");
          this.connection
            .invoke("cancelCall", this.object)
            .then(() => [this.connection.stop()]);

          this.$router.replace("/home");
          this.$store.dispatch("clearCallData");
        } else {
          console.log("you end");
          Axios.post(`${process.env.VUE_APP_BASE_URL}/system/endVideoCall`, {
            ...this.object,
            endReason: "patient"
          }).then(() => {
            // this.$router.go(-1);
            this.connection.stop();
            this.$router
              .replace("/home")
              .then()
              .catch(err => {});
            this.$store.dispatch("clearCallData");
          });
        }
      } else {
        console.log("not");
        this.connection.stop();
      }
    },
    showCam(roomName, twilioToken) {
      // createLocalVideoTrack().then(track => {
      //   const localMediaContainer = document.getElementById("local");
      //   localMediaContainer.setAttribute("playsinline", true);
      //   localMediaContainer.appendChild(track.attach());

      //   this.localTrack = track;
      // });
      //  navigator.mediaDevices
      //         .getUserMedia({ audio: true, video: true })
      //         .then(() =>{

      connect(twilioToken, {
        name: roomName
      })
        .then(room => {
          const localParticipant = room.localParticipant;
          console.log(
            `Connected to the Room as LocalParticipant "${localParticipant}"`
          );

          this.room = room;

          room.localParticipant.videoTracks.forEach(track => {
            const localMediaContainer = document.getElementById("local");
            localMediaContainer.setAttribute("playsinline", true);
            localMediaContainer.appendChild(track.track.attach());

            this.localTrack = track.track;
          });

          // this.localTrack = localParticipant.videoTracks.values().next().value.track
          // const localMediaContainer = document.getElementById("local");
          // localMediaContainer.appendChild(this.localTrack)

          console.log(room);

          // Log any Participants already connected to the Room
          room.participants.forEach(participant => {
            console.log(
              `Participant "${participant.identity}" is connected to the Room`
            );

            participant.tracks.forEach(publication => {
              if (publication.isSubscribed) {
                const track = publication.track;
                document.getElementById("remote").appendChild(track.attach());
              }
            });

            participant.on("trackSubscribed", track => {
              document.getElementById("remote").appendChild(track.attach());
            });

            participant.on("trackDisabled", track => {
              console.log("unsub", track);
            });

            participant.on("trackDisabled", track => {
              console.log("TRACKK", track);
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .removeChild(document.getElementsByTagName("video")[0]);
                this.acceptedCall = false;
              }
            });

            participant.on("trackEnabled", track => {
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .appendChild(track.track.attach());
                this.acceptedCall = true;
              }
            });
          });

          // Log Participants as they disconnect from the Room
          room.once("participantDisconnected", participant => {
            console.log(
              `Participant "${participant.identity}" has disconnected from the Room`
            );

            Axios.post(`${process.env.VUE_APP_BASE_URL}/system/endVideoCall`, {
              ...this.object,
              endReason: "patient"
            }).then(() => {
              //  this.$router.go(-1);
              this.$router
                .replace("/emergency/doctors")
                .then()
                .catch(err => {});
              this.$store.dispatch("clearCallData");
            });
          });

          room.on("participantConnected", participant => {
            console.log(`Participant "${participant.identity}" connected`);
            this.acceptedCall = true;
            this.loading = false;
            this.interval = setInterval(() => {
              this.timer++;
            }, 1000);

            participant.tracks.forEach(publication => {
              if (publication.isSubscribed) {
                const track = publication.track;
                document.getElementById("remote").appendChild(track.attach());
              }
            });

            participant.on("trackSubscribed", track => {
              document.getElementById("remote").appendChild(track.attach());
            });

            participant.on("trackDisabled", track => {
              console.log("TRACKK", track);
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .removeChild(document.getElementsByTagName("video")[0]);
                this.acceptedCall = false;
              }
            });

            participant.on("trackEnabled", track => {
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .appendChild(track.track.attach());
                this.acceptedCall = true;
              }
            });
          });
        })
        .catch(err => {
          //this.room.disconnect();

          console.log("errorcode", err);
          if (err.code === 0 || err.name === "NotAllowedError") {
            this.$store.dispatch("noPermission");
          }
          this.end();
        });
      //  })
      //  .catch(() => {
      //    this.end()
      //  })
    }
  },
  filters: {
    minuteSeconds: function(value) {
      const minutes = Math.floor(value / 60);
      return (
        minutes.toString().padStart(2, "0") +
        ":" +
        (value - minutes * 60).toString().padStart(2, "0")
      );
    }
  }
};
</script>


<style lang="scss" scoped>
.clock {
  position: absolute;
  top: 50px;
  //ght:20p1x;
  z-index: 10;
}
</style>

